import type {
  OnboardingV3FitnessScore,
  OnboardingV3PlanImpact,
} from "@/src/hooks/onboarding/onboardingV3Types";

/** MOCK — 屏A 视觉还原；Logic L12 替换为 session.fitnessScore */
export const MOCK_ONBOARDING_FITNESS_SCORE: OnboardingV3FitnessScore = {
  total: 72,
  control: 78,
  safety: 70,
  growth: 68,
  partial: true,
  headline: "More okay than you feel",
  scoreBasis:
    "A quick read from your answers. It sharpens the moment I can see your real accounts.",
};

/** MOCK — Plan impact 视觉还原；Logic L13 替换为 planPreview.impact */
export const MOCK_PLAN_IMPACT: OnboardingV3PlanImpact = {
  delta: 8,
  dimensions: ["control", "safety"],
};
